import React from 'react';
import { transformPosts } from '../utils/dataTransformers';
import { SummaryData } from '../types/socialGlass';

interface TopPostsSectionProps {
  summaryData: SummaryData | null;
  selectedCategory: string | null;
  onCategorySelect: (category: string) => void;
}

const TopPostsSection: React.FC<TopPostsSectionProps> = ({
  summaryData,
  selectedCategory,
  onCategorySelect,
}) => {
  const categories = summaryData?.TopPosts
    ? Object.keys(summaryData.TopPosts)
    : [];

  return (
    <div>
      <h2 className="mb-6 text-left text-2xl font-bold">Top Posts</h2>

      <div className="mb-6 flex flex-wrap gap-x-4 gap-y-6">
        {categories
          .sort(
            (a, b) =>
              transformPosts(summaryData, b).length - transformPosts(summaryData, a).length,
          )
          .map((cat) => (
            <button
              key={cat}
              onClick={() => onCategorySelect(cat)}
              className={`items-left justify-left flex flex-col rounded-2xl px-4 py-1 text-left transition-all ${
                selectedCategory === cat
                  ? "bg-[#FAD8D8] text-[#ED2C08] shadow-socialglass"
                  : "bg-transparent text-black hover:bg-[#FAD8D8]/60"
              }`}
            >
              <span className="text-[16px] font-medium">{cat}</span>
              <span className="text-[10px] italic text-gray-600">
                ({transformPosts(summaryData, cat).length} Submissions)
              </span>
            </button>
          ))}
      </div>
    </div>
  );
};

export default TopPostsSection;
